<template>
  <header class="safety-header" @click="$emit('toggle')">
    <div class="safety-header-title"><h2>{{ title }}</h2></div>
    <div class="safety-header-description">
      <p>{{ description }}</p>
    </div>
  </header>
</template>

<script setup>
defineProps({
  title: String,
  description: String,
})
</script>

<style scoped>
.safety-header {
  font-weight: 600;
  cursor: pointer;
  border-bottom: 0.5px solid var(--Dusk---Decorative-D20, #D3D6DF);
  padding: 24px 24px 16px 24px;
}
.safety-header-description{
    display: flex;
    align-items: baseline;
    p{
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      padding-top: 16px;
      padding-right: 20px;
    }
  }
</style>
